module.exports = __webpack_public_path__ + "static/media/projectsImage11.e1d0f0a2.jpg";